import React, { useState } from "react";
import { useBackendLinksProvider } from "../../../Providers/BackendLinksProvider.tsx";
import ModernMUITable from "../../../Components/ModernMUITable";
import { MobergButton, MobergButtonShape, MobergButtonVariant, MobergTheme } from "../../../Moberg";

const RMSelectPatient = (props) => {
    const { onNext: onNextProp, onBack: onBackProp, onClose, isModal = false } = props;
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    
    const { LINKS } = useBackendLinksProvider();

    const handlePaginationChange = (newModel) => {
        setPaginationModel(newModel);
    };

    const columns = [
        {
            field: "select",
            headerName: "",
            width: 90,
            minWidth: 90,
            maxWidth: 90,
            headerAlign: "center",
            align: "center",
            sortable: false,
            filterable: false,
            hideable: false,
            renderCell: (params) => {
                const patientId = params.row.patient_id || params.row.patientId || `Unknown-${params.row.id}`;
                const patientName = params.row.patient_name?.trim() ? params.row.patient_name : (params.row.name || "Unknown");
                return (
                    <MobergButton
                        variant={MobergButtonVariant.CLEAR}
                        theme={MobergTheme.BLUE}
                        shape={MobergButtonShape.RECTANGLE}
                        onClick={() => {
                            if (onNextProp) {
                                onNextProp(patientId, patientName);
                            }
                        }}
                        style={{ marginTop: '5px', height: '40px' }}
                    >
                        Select
                    </MobergButton>
                );
            },
        },
        {
            field: "patient_id",
            headerName: "Patient ID",
            minWidth: 200,
            flex: 0.4,
            visible: true,
            valueGetter: (value, row) => {
                return row.patient_id || `Unknown-${row.id}`;
            }
        },
        {
            field: "patient_name",
            headerName: "Name",
            minWidth: 200,
            flex: 0.4,
            visible: true,
            valueGetter: (value, row) => {
                return row.patient_name?.trim() ? row.patient_name : "Unknown";
            }
        },
    ];

    const tableToolbarProps = {
        createButton: { isShow: false },
        deleteButton: { isShow: false },
        filterButton: { isShow: false },
        exportButton: { isShow: false },
        searchInput: { 
            isShow: true,
            placeholder: "Search patient by patient ID or patient name"
        },
        columnButton: { isShow: false },
        mainTable: true
    };

    return (
        <div style={{ backgroundColor: "var(--color-surface-primary)", height: "100%", display: "flex", flexDirection: "column" }}>
            <div style={{ 
                position: 'relative', 
                padding: '10px 30px 20px', 
                height: isModal ? 'auto' : 'calc(100vh - 180px)',
                minHeight: '500px',
                maxHeight: isModal ? 'none' : '82vh',
                flex: isModal ? 1 : 'none',
                overflow: isModal ? 'hidden' : 'visible'
            }}>
                <ModernMUITable
                    queryKey="rm-select-patient"
                    endpoint={LINKS.DATA.PROFILING.GET_PATIENTS_CLINICAL}
                    body={{
                        admission_status: "discharged"
                    }}
                    columns={columns}
                    paginationModel={paginationModel}
                    onPaginationModelChange={handlePaginationChange}
                    tableToolbarProps={tableToolbarProps}
                    supportsPageSize={true}
                    pageSizeOptions={[10]}
                    isRowSelectable={() => false}
                    isCheckboxSelection={false}
                    checkboxSelection={false}
                    height="100%"
                    paginationMode="server"
                    sortingMode="client"
                />
            </div>
        </div>
    );
};

export default RMSelectPatient;
